import React from "react";

export default (props) => {
  return (
    <React.Fragment>
      <p>You cannot submit your chosen evidence via MyScan. You will need to take the original documentation to the Civic Centre so that a member of staff can check it.</p>
      <br />
    </React.Fragment>);
}
